export default __webpack_public_path__ + "static/media/download-white.2e9600a4.svg";